import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import apiClient from "../../apiClient";

export const AvatarSelection = ({ updateAvatar }) => {
  const userData = useSelector((state) => state.userSlice);
  const configData = useSelector((state) => state.configSlice);
  const { config } = configData;
  const [loadAvatar, setLoadAvatar] = useState(false);
  const [gender, setGender] = useState("male");
  const [avatars, setAvatars] = useState([]);
  const [selectedAvatar, setSelectedAvatar] = useState({});
  const isLoggedIn = userData.token.length > 0 ? true : false;
  const [username, setUsername] = useState("");
  const checkDefaultAvatar = (avatarData) => {
    if (!isLoggedIn || !userData.user?.metaData?.playerAvatar)
      return avatarData[0] ? setSelectedAvatar(avatarData[0]) : null;
    avatarData.some((i) => i.assets.some((j) => j.url === userData.user.metaData.playerAvatar && setSelectedAvatar(i)));
  };
  const loadAvatars = async () => {
    setAvatars([]);
    setSelectedAvatar({});
    try {

      const data = await apiClient.get(`${config.UNO_URL}/api/resource/3d/character/list/public/universal/${gender}`);
      // let { data } = await axios.get(`${config.UNO_URL}/api/resource/3d/character/list/public/universal/${gender}`, {
      //   headers: {
      //     Authorization: `Bearer ${userData.token}`,
      //   },
      // });
      setAvatars(data);
      checkDefaultAvatar(data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    loadAvatars();
    if (isLoggedIn) {
      setUsername(userData.user.name);
    }
  }, [gender]);
  const proceed = async () => {
    try {
      var playerAvatar = selectedAvatar.assets.filter((e) => e.type === "GLB")[0].url;
      updateAvatar({ name: username, playerAvatar });
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <div className="left-parent">
        <div className="left-avtars">
          <span className="avatar-head">
            <p>Select Avatar</p>
            <span className="select-tab">
              <p onClick={() => setGender("male")} className={gender == "male" ? "active" : ""}>
                Male
              </p>{" "}
              |{" "}
              {
                <p onClick={() => setGender("female")} className={gender == "female" ? "active" : ""}>
                  Female
                </p>
              }
            </span>
          </span>
          {/* <div className='load-parent'>
                        <div className='load-avatar'>
                            <svg viewBox="25 25 50 50">
                                <circle r="20" cy="50" cx="50"></circle>
                            </svg>
                        </div>
                    </div> */}
          <div className="avatar-list">
            {avatars.map((item, index) => (
              <div onClick={() => setSelectedAvatar(item)} className="avatar-box" key={index}>
                <div className="avatar-cap">
                  <img src={item.thumbnail} alt="Avatar" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="right-names">
        <input
          className="namesearch"
          type="text"
          placeholder="Enter your name"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <div className="avatar-display">
          {/* {loadAvatar ?
                        <>
                            <div className='load-avatar'>
                                <svg viewBox="25 25 50 50">
                                    <circle r="20" cy="50" cx="50"></circle>
                                </svg>
                            </div>
                        </>
                        : */}
          {selectedAvatar.uuid && (
            <>
              <img src={selectedAvatar.thumbnail} alt="Avatar" />
            </>
          )}
          {/* } */}
          {selectedAvatar.uuid && username.length > 3 ? (
            <span className="action-btn" onClick={() => proceed()}>
              Next
            </span>
          ) : null}
        </div>
      </div>
    </>
  );
};
